import React from 'react';
import { User as UserComponent } from '@lyearn-team/frontend-components';
import themeConfig from '@lyearn-team/theme-config';
import * as DateHelper from '../../../helper/DateHelper';

const renderTeacherArray = teachers =>
  teachers.map((teacher, i) => (
    <div key={i} className={'teacherElem' + (teachers.length === i + 1 ? ' last' : '')}>
      <UserComponent
        style={{ color: themeConfig.color.grey1 }}
        picture={teacher.picture}
        name={teacher.name}
        size="medium"
        hideEmail={true}
      />
    </div>
  ));

const renderTeachers = teachers => {
  if (!teachers || teachers.length === 0) {
    return null;
  }
  return [
    <div key={1} className="detailHeader">
      Teachers
    </div>,
    <div key={2} className="detailContent">
      {renderTeacherArray(teachers)}
    </div>
  ];
};

const CourseOverview = props => {
  const { description, teachers } = props.course;
  let duration = 0;
  const sectionLevelDurations = props.course.sections.edges.map(section =>
    Math.ceil(section.node.cards.edges.reduce((sum, card) => card.node.duration + sum, 0) / 60)
  );
  sectionLevelDurations.forEach(value => (duration += value));
  return (
    <div className="courseDetailContainer courseOverviewContainer">
      <div className="detailContent">{description}</div>
      <div className="detailHeader">Estimated Duration</div>
      <div className="detailContent">{DateHelper.getFormattedDuration(duration * 60, true)}</div>
      {renderTeachers(teachers)}
    </div>
  );
};

export default CourseOverview;
